export const TITLE = 'Новый бланк';
export const INFO_TITLE = 'Информация о клиенте';
export const DATE_BLANK = 'Дата заполнения бланка';
export const FAMILY_NAME_BLANK = 'Фамилия';
export const NAME_BLANK = 'Имя';
export const SURNAME_BLANK = 'Отчество';
export const YEAR_BLANK = 'Год рождения';
export const GENDER_BLANK = 'Пол';
export const INSTITUTION_BLANK = 'Учреждение';
export const PROGRAM_BLANK = 'Программа';
export const QUESTIONS_BLANK = 'Кто отвечает на вопросы';
export const DIAGNOSIS_BLANK = 'Основной диагноз';
export const ADDITIONAL_INFO_BLANK = 'Дополнительные сведения';
export const CLIENT_REQUEST_BLANK = 'Запрос клиента';
export const INTERVIEW_DATE_BLANK = 'Планируемая дата следующего интервью';
export const AGREEMENT_BLANK = 'Пользовательские соглашения';
export const EMAIL_BLANK = 'Email';
export const BTN_SEND = 'Отправить';
export const SAVE = 'Сохранить и перейти далее';
export const TOOLTIP =
	'Клиенту необходимо ознакомиться с пользовательскими соглашениями и отправить в течение суток свое согласие на почту, с которой пришло письмо';
export const PROBLEM_TITLE = 'Определение проблем и оценка важности';
export const TITLE_DESCRIPTION = 'Описание проблемы';
export const SECTION = 'Раздел';
export const SUBSECTION = 'Подраздел';
export const PROBLEM_DESCRIPTION = 'Описание проблемы';
export const SHORT_PROBLEM_DESCRIPTION = 'Коротко опишите проблему';
export const GRADE = 'Важность(от 1 до 10)';
export const CHOOSE_SECTION = 'Выберите раздел';
export const CHOOSE_SUBSECTION = 'Выберите подраздел';
export const ADD_DESCRIPTION = 'Добавить еще описание';
export const BACK = 'На предыдущий шаг';
export const FAMILY_NAME = 'Введите фамилию клиента';
export const NAME = 'Введите имя клиента';
export const SURNAME = 'Введите отчество клиента';
export const YEAR = 'Выберите год';
export const INSTITUTION = 'Выберите учреждение';
export const PROGRAM = 'Введите название программы, категорию услуги';
export const QUESTIONS = 'Сам клиент или его представитель';
export const DIAGNOSIS = 'Предполагаемый, имеющийся, проблема, гипотеза, дата постановки диагноза';
export const ADDITIONAL_INFO = 'Сопутствующие заболевания, госпитализации, примечания и т.д.';
export const CLIENT_REQUEST = 'Первая формулировка самим клиентом';
export const EMAIL = 'Введите email клиента';
export const SELF_SERVICE = 'Cамообслуживание';
export const PRODUCTIVE_ACTIVITY = 'Продуктивная деятельность';
export const LEISURE = 'Досуг';
export const PERSONAL_CARE = 'Уход за собой';
export const FUNCTIONAL_MOBILITY = 'Функциональная мобильность';
export const SOCIAL_ACTIVITY = 'Социальная активность';
export const ERROR = 'Неизвестная ошибка';
export const ADMINISTRATION = 'Обратитесь к администратору';
export const EMAIL_ADMINISTRATOR = 'edu@fond-igra.ru';
export const REBOOT = 'Перезагрузить страницу';
export const CONFIRMATION_DELETE = 'Подтверждение удаления';
export const DELETE_QUESTION = 'Вы уверены, что хотите удалить данное описание проблемы?';
export const CANCEL = 'Отменить';
export const DELETE = 'Да,удалить';
export const VOICE_MODAL = 'Голосовой ввод описания проблемы';
export const VOICE_BTN = 'Для записи нажмите на кнопку';
export const START_RECORD = 'Начать запись';
export const PLACEHOLDER_VOICE = 'Транскрибация записанного голоса в текст';
export const DELETE_RECORD = 'Удалить запись';
export const SAVE_VOICE = 'Сохранить описание';
export const HINTS = 'Подсказки';
export const PROBLEM_AREAS = 'Возможные проблемные сферы:';
export const CLIENT_DAY = 'Как проходит обычный день клиента';
export const EVERYDAY_ACTIVITY = 'Активности в повседневной жизни, которые:';
export const WANTS = 'он хотел бы делать';
export const NEEDED = 'ему необходимо делать';
export const EXPECTED = 'выполнение которых ожидают от него окружающие';
export const HINTS_QUESTION =
	'Какие виды деятельности сейчас сложно выполнять или не приносят удовлетворения тем, как выполняются?';
export const TITLE_THREE = 'Оценка выполнения и удовлетворенности';
export const ASSESSMENT = 'Оценка 1';
export const GOAL_TITLE = 'Цель и ее достижение';
export const GOAL = 'Цель';
export const PLACEHOLDER_GOAL = 'Опишите цель';
export const EXAMPLE_GOAL =
	'Пример: «Через 2 месяца Петя может сидеть на стуле со спущенными ногами в течение 10 минут, пока мама надевает на него футболку и кофту';
export const GOAL_PLAN = 'Краткий план достижения цели';
export const STEPS_PLAN = 'Опишите последовательность действий в несколько шагов';
export const FINAL_SAVE = 'Сохранить';
export const EVALUATE_ACTIVITY =
	'Попросите клиента оценить каждую «проблемную» активность с точки зрения ее выполнения';
export const SATISFACTION_ACTIVITY =
	'Попросите клиента оценить каждую «проблемную» активность с точки зрения удовлетворенности ее выполнением';
export const SCALE = 'по 10-бальной шкале, где 1 - совсем не получается, 10 - отлично получается';
export const SCALE_SATISFACTION = 'по 10-бальной шкале, где 1 - совсем не удовлетворен, 10 - полностью удовлетворен';
export const HINTS_QUESTIONS = 'Укажите цель одним предложением, отвечая на вопросы:';
export const ACHIEVEMENTS = 'Что конкретно необходимо достичь/сделать?';
export const RESULT = 'Как будет оценен результат?';
export const DEADLINES = 'В какие сроки цель должна быть достигнута?';
export const DOING = 'Выполнение (от 1 до 10)';
export const SATISFACTION = 'Удовлетворенность (от 1 до 10)';
export const PREFICS = 'Префикс';
export const DOMEN = 'МКФ-код';
export const CHOOSE = 'Выберите';
export const CHOOSE_SPOKESMAN = 'Выберите кто отвечает на вопросы';
export const CHOOSE_VIOLATIONS = 'Выберите основные виды нарушений';
export const MKF = 'МКФ-код';
export const RETURN_QUESTION = 'Вы уверены, что хотите покинуть экран?';
export const RETURN_TEXT = 'Некоторые данные текущего шага могут не сохраниться';
export const RETURN_STAY = 'Остаться';
export const RETURN_BTN = 'Да, выйти';
export const GENDER_MAPPING: Record<string, string> = {
	'М': 'MALE',
	'Ж': 'FEMALE',
};
export const REVERSE_GENDER_MAPPING: Record<string, string> = {
	'MALE': 'М',
	'FEMALE': 'Ж',
};
export const SPOKSMAN_MAPPING: Record<string, string> = {
	'Представитель': 'CLIENT_REPRESENTATIVE',
	'Клиент': 'CLIENT',
};
export const REVERSE_SPOKSMAN_MAPPING: Record<string, string> = {
	'CLIENT_REPRESENTATIVE': 'Представитель',
	'CLIENT': 'Клиент',
};
export const MAIN_TYPES_VIOALATIONS = 'Основные виды нарушений';
export const VIOLATIONS = [
	'ДЦП (детский церебральный паралич)',
	'СМА (спинальная мышечная атрофия) и родственные синдромы',
	'Спина бифида и другие врожденные аномалии н/с',
	'Синдром Дауна',
	'ТМНР (тяжелые множественные нарушения развития)',
	'РАС (расстройства аутистического спектра)',
	'Инсульт и другие цереброваскулярные болезни',
	'ЧМТ (черепно-мозговые травмы)',
	'Генетические болезни',
	'Несовершенный остеогенез и другие болезни костной и соединительной ткани',
	'Новообразования нервной системы',
	'Психические и поведенческие расстройства',
	'Деменция',
	'Болезнь Паркинсона и другие экстрапирамидные расстройства',
	'Травмы и ортопедические заболевания',
	'Онкологические заболевания',
	'Эпилепсия и родственные синдромы',
	'Не установлено',
];
